<template>
  <v-card outlined>
    <v-card-title>
      <v-icon class="material-icons" color="primary"> school </v-icon>
      <span class="ml-2 text-subtitle-2">Lớp bổ trợ</span>
      <v-spacer></v-spacer>
      <v-btn class="text-none" color="primary" text :to="'/classes'">Xem chi tiết</v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-container>
        <div class="d-flex flex-nowrap container">
          <v-simple-table style="width: 100%" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" :to="'/student/63be6c68af0f83107f4cdfc0'">Tên Lớp</th>
                  <th class="text-left">Môn học</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in classes" :key="item.id">
                  <td>
                    <router-link style="text-decoration: none" :to="'/class/' + item.id">
                      <div style="white-space: nowrap">
                        {{ item.title }}
                      </div>
                    </router-link>
                  </td>
                  <td>{{ item.extraSubject.title }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  components: {},
  props: {
    student: Object,
  },
  data() {
    return {
      tab: null,
      classes: [],
    }
  },
  mounted() {
    this.filterExtraClass()
  },
  methods: {
    filterExtraClass() {
      this.classes = this.student.classes.filter((item) => item.type === 'extraCurriculum')
    },
  },
  watch: {
    student: {
      handler: 'filterExtraClass',
      immediate: true,
    },
  },
}
</script>
  <style scoped lang="scss">
.title {
  min-width: 300px;
}
-title {
  min-width: 150px;
}
table {
  border-collapse: collapse;
}
tr {
  border-bottom: 1px solid lightgrey;
}
.container {
  overflow-x: auto;
  max-width: 100%;
}
.container::-webkit-scrollbar {
  -webkit-appearance: none;
}
.container::-webkit-scrollbar:horizontal {
  height: 10px;
}
.container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
